import type { PropsWithChildren } from 'react'

import type { Workflow } from '@fv/models'

import { useCurrentUser } from '@/hooks/settings/useAppContext'

type Props = PropsWithChildren<{ workflow: Workflow }>

export function useWorkflowEnabled(workflow: Workflow) {
  const { allowedWorkflows } = useCurrentUser()
  return allowedWorkflows.includes(workflow)
}

export const HasWorkflow = ({ children, workflow }: Props) => {
  const { workflows } = useCurrentUser()
  if (!workflows.includes(workflow)) return null
  return <>{children}</>
}

export const WorkflowEnabled = ({ children, workflow }: Props) => {
  if (!useWorkflowEnabled(workflow)) return null
  return <>{children}</>
}
